import { heroImage, type LandingPage } from "@/lib/data/landing/types"

// TODO(photo): MIU in-house shoot needed for Blueberry Matcha and Matchanana
// Latte (no photo yet), plus a wide shot of the seating area with someone
// working on a laptop for the "Stay and work" section. Add drink shots to
// toast-menu-images.ts under the item's exact Toast name.
export const MATCHA_PAGE: LandingPage = {
  path: "/matcha",
  breadcrumb: "Matcha",
  title: "Matcha Lattes in Rancho Cucamonga | +Bake Cafe",
  description:
    "Strawberry matcha, blueberry matcha, Matchanana and houjicha lattes at +Bake Cafe on Base Line Rd, Rancho Cucamonga. Oat, almond and coconut milk available.",
  eyebrow: "Matcha series",
  h1: "Matcha at +Bake Cafe",
  intro:
    "The strawberry matcha latte is one of the two drinks people order most at +Bake. It is matcha, milk, and a house strawberry compote. The rest of the matcha menu builds from there: blueberry, banana, and a roasted houjicha for anyone who wants something toastier.",
  hero: heroImage(
    "matcha-hero",
    "Iced strawberry matcha latte at +Bake Cafe",
  ),
  trackingLocation: "matcha_page",
  sections: [
    {
      id: "menu",
      heading: "The matcha menu",
      paragraphs: [
        "Every drink in the series starts with matcha and milk. The fruit versions add a compote or banana, which sweetens the drink and softens the grassy edge of the tea. If you've never had matcha, the strawberry is the easiest place to start. If you already drink it straight, try the plain matcha latte first.",
      ],
      items: [
        { name: "Matcha Latte" },
        {
          name: "Strawberry Matcha Latte",
          image: "/images/plusbake/menu/strawberry-matcha-latte.webp",
        },
        { name: "Blueberry Matcha" },
        { name: "Matchanana Latte" },
        {
          name: "Houjicha Latte",
          note: "Houjicha / milk / simple syrup. Roasted green tea: toasty and lower in caffeine than matcha.",
        },
      ],
    },
    {
      id: "matcha-or-houjicha",
      heading: "Matcha or houjicha?",
      paragraphs: [
        "Both are Japanese green teas, prepared differently. Matcha is shade-grown tea ground into a fine powder, so you drink the whole leaf: bright green, grassy, and higher in caffeine. Houjicha is green tea roasted after drying, which turns it brown and gives it a nutty, toasted flavor with less caffeine.",
        "If you want something bright, or something with fruit, stay with matcha. If you usually order a latte for the warmth and the milk, try the houjicha.",
      ],
    },
    {
      id: "milk-and-foam",
      heading: "Milk swaps and matcha foam",
      paragraphs: [
        "Any matcha drink can be made with oat, almond or coconut milk for $1 more. Ask at the counter, or pick the milk when you order on Toast.",
        "Matcha foam is a $1 add-on: a layer of whipped matcha on top for a stronger tea flavor in the first few sips. Ask for it at the counter or add it on Toast.",
      ],
    },
    {
      id: "pairing",
      heading: "What to eat with it",
      paragraphs: [
        "Matcha goes well with something savory or something with warm spice. The garlic cream cheese salt bread and the Pandan Biscoff Snickerdoodle are the two we'd put next to a strawberry matcha.",
      ],
      items: [
        { name: "Garlic Cream Cheese Salt Bread" },
        { name: "Pandan Biscoff Snickerdoodle" },
      ],
      links: [
        { label: "All salt bread", to: "salt-bread" },
        { label: "Coffee and espresso drinks", to: "coffee" },
      ],
    },
    {
      id: "stay-and-work",
      heading: "Stay and work",
      paragraphs: [
        "+Bake has free Wi-Fi, indoor seating and a patio with umbrellas, and plenty of people settle in with a matcha and a laptop. We're open daily from 7:30 AM to 3:30 PM, and there's free parking in the Sunrize Center lot out front.",
      ],
      links: [{ label: "Hours & directions", to: "visit" }],
    },
    {
      id: "order-ahead",
      heading: "Order ahead",
      paragraphs: [
        "Every matcha drink is on Toast for pickup, next to the pastry case. Order before you leave, pick your milk and add any sweetness notes, and it will be waiting at the pickup shelf when you walk in to 8685 Base Line Rd, Ste B.",
      ],
    },
  ],
  faq: [
    {
      q: "Can I adjust sweetness?",
      a: "Ask at the counter or add a note on your Toast order.",
    },
    {
      q: "Do you have dairy-free milk?",
      a: "Oat, almond, and coconut milk for $1.",
    },
    {
      q: "Can I work from the cafe?",
      a: "Yes, there is Wi-Fi and indoor seating. The cafe is open until 3:30 PM.",
    },
  ],
}
